import { CommentBubble, CommentBubbleSolid } from '@byway/icons';
import clsx from 'clsx';
import { useTranslations } from 'next-intl';
import { Link } from '~/components/Link';
import styles from './TripContact.module.css';

type TripContactLinkProps = {
  tripId?: string;
  variant: 'filled' | 'ghost';
};

export const TripContactLink = ({ tripId, variant }: Readonly<TripContactLinkProps>) => {
  const t = useTranslations('common');

  return (
    <span className={clsx(styles.link, variant === 'filled' ? styles.linkFilled : styles.linkGhost)}>
      <Link isUnstyled href={tripId ? `/contact?tripId=${tripId}` : '/contact'} data-ua-click="contact-button">
        {variant === 'filled' ? (
          <CommentBubbleSolid decorative size="large" strokeWidth={1} />
        ) : (
          <CommentBubble decorative size="large" />
        )}
        <span>{t('contact')}</span>
      </Link>
    </span>
  );
};
